export {default as Welcome} from './Welcome'
export {default as Content} from '../components/Content'
export {default as Image} from '../components/Image'
export {default as SlideSpeakers} from './Speakers'
export {default as SlideSpeaker} from './Speaker'
export {default as Conclusion} from './Conclusion'
export {default as ThankYou} from './ThankYou'

export {default as Section} from './Section'
export {default as Slide} from './Slide'
